/* lua.js generated code 0.3.0 */
 //require "clover.config.LevelConfig"
require("clover/config/level/TileItem")
require("clover/config/level/LevelConfigManager")
